

































import { computed, defineComponent, PropType } from '@vue/composition-api';
import { isNil } from 'ramda';
import { SortToggleOption, SortToggleOptionDirection } from '../types';
import { match } from 'ts-pattern';

export default defineComponent({
    name: 'SortToggle',
    model: {
        prop: 'selection',
        event: 'update-selection',
    },
    props: {
        selection: {
            type: Object as PropType<{ key: string; direction: string }>,
        },
        options: {
            type: Array as PropType<SortToggleOption[]>,
            required: true,
        },
        disabled: { type: Boolean, default: false },
    },
    setup(props, { emit }) {
        const findDirection = (option: SortToggleOption, direction: string): SortToggleOptionDirection | undefined =>
            option.directions.find((dir: SortToggleOptionDirection) => dir.direction === direction);

        const nextDirection = (option: SortToggleOption) => {
            if (isNil(props.selection) || option.key !== props.selection.key)
                emit('update-selection', { key: option.key, direction: option.directions[0].direction });
            else {
                const lastDirectionIndex = option.directions.findIndex(
                    (dir: SortToggleOptionDirection) => dir.direction === props.selection?.direction,
                );
                if (lastDirectionIndex < option.directions.length - 1)
                    emit('update-selection', {
                        key: option.key,
                        direction: option.directions[lastDirectionIndex + 1].direction,
                    });
                else emit('update-selection', { key: option.key, direction: option.directions[0].direction });
            }
        };

        const colsClass = computed(() =>
            match<number, string>(props.options.length)
                .with(1, () => 'grid-cols-1')
                .with(2, () => 'grid-cols-2')
                .with(3, () => 'grid-cols-3')
                .with(4, () => 'grid-cols-4')
                .with(5, () => 'grid-cols-5')
                .with(6, () => 'grid-cols-6')
                .with(7, () => 'grid-cols-7')
                .with(8, () => 'grid-cols-8')
                .otherwise(() => `grid-cols-10`),
        );
        return { isNil, findDirection, nextDirection, colsClass };
    },
});
